__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "you-payment";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@frontend/dynamic-wrapper", "0.0.1", () => (() => (__webpack_require__(71281))), 1);
			register("@frontend/feature-monitor", "0.0.0", () => (() => (__webpack_require__(15882))), 1);
			register("@frontend/you-shared-ui", "0.0.0", () => (() => (__webpack_require__(94295))), 1);
			register("i18next", "23.16.8", () => (() => (__webpack_require__(40680))), 1);
			register("launchdarkly-react-client-sdk", "3.6.1", () => (() => (__webpack_require__(56550))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(35623))), 1);
			register("react-i18next", "13.5.0", () => (() => (__webpack_require__(44691))), 1);
			register("react-router-dom", "6.11.2", () => (() => (__webpack_require__(51171))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(86326))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};